import cn from 'classnames';
import React from 'react';

import { PictureDefaultProps, PicturePropTypes } from './Picture.proptypes';
import usePicture from './usePicture';

const Picture = ({ alt, className, onLoadImage, src }) => {
  const { hasError, image, onErrorImage } = usePicture({
    src,
  });

  return (
    <img
      alt={alt}
      className={cn('picture', {
        'picture--bg-placeholder': hasError,
        [className]: !hasError,
      })}
      onError={onErrorImage}
      onLoad={onLoadImage}
      src={image}
    />
  );
};

Picture.defaultProps = {
  ...PictureDefaultProps,
};

Picture.propTypes = {
  ...PicturePropTypes,
};

export default Picture;
